<script setup>
import {onMounted, ref} from "vue";
import http from "@/http";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";

const router = useRouter();
const route = useRoute();
const loading = ref(false);
const regionLoading = ref(false);
const districtLoading = ref(false);
const form = ref({
  id: null,
  region_id: null,
  district_id: null,
  board_id: null,
  price: null,
  half_ready_price: null
});

const boards = ref([]);
const regions = ref([]);
const districts = ref([]);
const formRef = ref();

const rules = {
  region_id: [
    {required: true, message: "Majburiy maydon", trigger: "change"},
  ],
  district_id: [
    {required: true, message: "Majburiy maydon", trigger: "change"},
  ],
  board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
  price: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
  half_ready_price: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
};

const getBoards = () => {
  loading.value = true;
  http({url: `api/v1/boards`, params: {status: 1}})
      .then(({data}) => {
        boards.value = data.boards;
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};
const onChangeRegion = () => {
  getDistricts();
};

const getRegions = () => {
  regionLoading.value = true;
  http({url: "/api/v1/regions"})
      .then(({data}) => {
        regions.value = data.regions;
      })
      .catch(() => {
        ElMessage.error(`Viloyatlar yuklanmadi. Qayta urinib ko'ring`);
      })
      .finally(() => {
        regionLoading.value = false;
      });
};
const getDistricts = () => {
  districtLoading.value = true;
  http({url: `/api/v1/districts?region_id=${form.value.region_id}`})
      .then(({data}) => {
        districts.value = data.districts;
      })
      .catch(() => {
        ElMessage.error(`Tumanlar yuklanmadi. Qayta urinib ko'ring`);
      })
      .finally(() => {
        districtLoading.value = false;
      });
};

const getRoadPriceById = () => {
  loading.value = true;
  http({url: `api/v1/road-prices/${form.value.id}`})
      .then(({data}) => {
        form.value = data;
        if (form.value.region_id) {
          getDistricts();
        }
      })
      .catch((err) => {
        ElMessage.error(
            err.response.data.message || `Hatolik qayta urinib ko'ring`
        );
      })
      .finally(() => {
        loading.value = false;
      });
};

const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid) => {
    if (valid) {
      loading.value = true;
      http({
        url: `api/v1/road-prices${form.value.id ? `/${form.value.id}` : ""}`,
        data: form.value,
        method: form.value.id ? "put" : "post",
      })
          .then(() => {
            router.go(-1);
          })
          .catch((err) => {
            ElMessage.error(
                err.response.data.message || `Hatolik qayta urinib ko'ring`
            );
          })
          .finally(() => {
            loading.value = false;
          });
    }
  });
};

onMounted(() => {
  if (route.params.id) {
    form.value.id = route.params.id;
    getRoadPriceById();
  }
  getBoards();
  getRegions();
});
</script>

<template>
  <p style="font-size: 18px" class="pb-8">
    {{ form.id ? "Taxrirlash" : `Qo'shish` }}
  </p>
  <el-row class="add-news">
    <el-col :xs="24" :sm="18" :md="12" :lg="12" :xl="8">
      <el-form
          label-position="top"
          v-loading="loading"
          ref="formRef"
          :rules="rules"
          :model="form"
      >
        <el-form-item label="Boardni tanlang" prop="board_id">
          <el-select size="large" v-model="form.board_id" style="width: 100%">
            <el-option
                v-for="board in boards"
                :key="board.id"
                :value="board.id"
                :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Viloyatni tanlang" prop="region_id">
          <el-select
              style="width: 100%"
              v-loading="regionLoading"
              v-model="form.region_id"
              @change="onChangeRegion"
              size="large"
              placeholder="Viloyat"
          >
            <el-option
                v-for="region in regions"
                :value="region.id"
                :label="region.title"
                :key="region.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Tumanni tanlang" prop="district_id">
          <el-select
              style="width: 100%"
              v-loading="districtLoading"
              v-model="form.district_id"
              size="large"
              @change="onChangeDistrict"
              placeholder="Tuman"
          >
            <el-option
                v-for="district in districts"
                :value="district.id"
                :label="district.title"
                :key="district.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Narxni kiriting" prop="price">
          <el-input-number style="width: 100%" size="large" v-model="form.price" type="number"/>
        </el-form-item>

        <el-form-item label="Yarim tayyor yo'l narxini" prop="half_ready_price">
          <el-input-number style="width: 100%" size="large" v-model="form.half_ready_price" type="number"/>
        </el-form-item>
        <div class="mt-15 text-right">
          <el-button
              @click="$router.go(-1)"
              class="el-button el-button--danger"
          >
            Bekor qilish
          </el-button>
          <el-button type="primary" @click="submitForm(formRef)"
          >Saqlash
          </el-button>
        </div>
      </el-form>
    </el-col>
  </el-row>
</template>

<style scoped lang="scss">
.text-right {
  text-align: right;
}

a {
  text-decoration: none;
}
</style>
